import { MealId } from '../model/types';

const RELATED_MEAL_IDS: Partial<Record<MealId, readonly MealId[]>> = {
  [MealId.AllInclusive]: [MealId.UltraAllInclusive, MealId.AllInclusiveNoAlcohol],
  [MealId.Breakfast]: [MealId.Lunch, MealId.Dinner, MealId.BreakfastWithTreatment, MealId.Program],
  [MealId.FullBoard]: [MealId.FullBoardWithDrinks, MealId.FullBoardWithTreatment],
  [MealId.HalfBoard]: [MealId.HalfBoardWithDrinks, MealId.HalfBoardWithTreatment],
  [MealId.RoomOnly]: [MealId.RoomOnlyWithTreatment],
};

export function getSearchMealIds(mealIds: readonly number[]): number[] {
  const searchMealIds = mealIds.flatMap((mealId) => [mealId, ...(RELATED_MEAL_IDS[mealId as MealId] ?? [])]);

  return Array.from(new Set(searchMealIds));
}
